import { useDatasetContext } from '../../../../../hooks/context/useDatasetContext';
import { useSelectedRowsContext } from '../../../../../hooks/context/useSelectedRowsContext';
import { useResolvedLabel } from '../../../../../hooks/useResolvedLabel';
import SelectedRowsCounter from '../../../SelectedRowsCounter/SelectedRowsCounter';

const HeaderLabel = () => {
  const { dataset } = useDatasetContext();
  const { selectedRows, selectedVirtualRows } = useSelectedRowsContext();
  const label = useResolvedLabel(dataset?.label);

  return (
    <div className="header-label-container">
      <h1>
        {label}
        <SelectedRowsCounter
          selectedRows={selectedRows}
          selectedVirtualRows={selectedVirtualRows}
        />
      </h1>
    </div>
  );
};

export default HeaderLabel;
